import { isEmpty } from 'lodash';
import { IGcfProductListProductImage } from 'src/interfaces/Product';

import { IProductVariationsAssets } from '../../../../MenuBoardModificationPage.interface';

export const getReplaceModalAssets = (
  productVariationsAssets: IProductVariationsAssets,
  defaultFlavor?: string,
  defaultImage?: IGcfProductListProductImage,
) => {
  if (
    !defaultFlavor ||
    !defaultImage?.assetName ||
    isEmpty(productVariationsAssets)
  )
    return [];

  const assetName = defaultImage.assetName;

  return (productVariationsAssets[defaultFlavor] ?? []).filter(
    (asset) => asset.name !== assetName,
  );
};
